module.exports = __webpack_public_path__ + "img/demo.3603a25.svg";